import { formatMessage } from 'lib/intl'

export const NODE_INPUT = 'INPUT'
export const NODE_SELECT = 'SELECT'
export const NODE_TEXTAREA = 'TEXTAREA'
export const ENTER_KEY_CODE = 13
export const INPUT_FIELD_TYPES = {
  select: formatMessage('select'),
  number: formatMessage('number'),
  string: formatMessage('string'),
  date: formatMessage('date'),
  time: formatMessage('time'),
  boolean: formatMessage('boolean'),
  file: formatMessage('file'),
  constant_value: formatMessage('constant_value'),
}

export const onFormInputEnterPress = (
  { keyCode, shiftKey, ctrlKey, target },
  callback,
  callbackArgs,
) => {
  const isTextarea = target.nodeName === NODE_TEXTAREA

  if (
    keyCode !== ENTER_KEY_CODE ||
    (shiftKey && ctrlKey) ||
    (isTextarea && !shiftKey && !ctrlKey)
  ) {
    return
  }

  const enterInputList = [...document.querySelectorAll('.js-enter-press-input')]
  const currentIndex = enterInputList.findIndex(node => node === target)
  const firstIndex = 0
  const lastIndex = enterInputList.length - 1

  if (currentIndex === -1) {
    return
  }

  if (currentIndex === firstIndex && shiftKey) {
    enterInputList[lastIndex].focus()

    return
  }

  if (currentIndex === lastIndex && !shiftKey) {
    enterInputList[firstIndex].focus()

    return
  }

  const nextIndex = shiftKey ? currentIndex - 1 : currentIndex + 1
  enterInputList[nextIndex].focus()

  if (typeof callback === 'function') {
    callback(callbackArgs)
  }
}
